var $ = require('jquery');
/* global diy */
(function() {
    'use strict';

    var toolbar;
    var layerManager;

    var module = angular.module('diy.notification', ['ngResource']);

    module.factory('websiteId', function() {
        return window.script_basisID;
    });

    //Copy paste from file manager
    module.config(["$httpProvider", function($httpProvider) {
        var defaultHeaders = $httpProvider.defaults.headers;
        defaultHeaders.common['X-DiyCSRFToken'] = jimdoData.cstok;
        // this header is essential in session expiration handling
        defaultHeaders.common['X-Requested-With'] = 'XMLHttpRequest';
        /**
         * this assures that the angular app will route all error $http's through session expiry js check
         */
        $httpProvider.interceptors.push(diy.editor.session.angularHandleExpired);
    }]);

    module.run(['ntfApi', function(ntfApi) {
        var ns = diy.core.namespace('diy.editor.notifications.api');
        ns.createNotification = $.proxy(ntfApi.createNotification, ntfApi);
        ns.getNotificationInfo = $.proxy(ntfApi.getNotificationById, ntfApi);
        ns.getNotificationsByType = $.proxy(ntfApi.getNotificationsByType, ntfApi);
        ns.deleteNotification = $.proxy(ntfApi.deleteNotification, ntfApi);
        ns.updateNotification = $.proxy(ntfApi.updateNotification, ntfApi);
        ns.deleteNotificationByType = $.proxy(ntfApi.deleteNotificationByType, ntfApi);
        ns.pause = $.proxy(ntfApi.pause, ntfApi);
        ns.resume = $.proxy(ntfApi.resume, ntfApi);
    }]);

    module.service('ntfRest', ['$resource', '$http', 'websiteId', function($resource, $http, websiteId) {
        var baseUrl = '/rest/websites/' + websiteId + '/notification';
        var resource = $resource(baseUrl + '/:id', {
            id: '@id'
        }, {
            'create': {method: 'POST'},
            'update': {method: 'PUT'},
            'markread': {method: 'PUT', params: {id: 'markread'}},
            'markdismissed': {method: 'PUT', params: {id: 'markdismissed'}},
            'batchSoftDelete': {method: 'PUT', params: {id: 'batchSoftDelete'}}
        });

        resource.batchDelete = function(ids) {
            return $http({
                method: 'DELETE',
                url: baseUrl,
                data: {ids: ids}
            });
        };

        resource.deleteByType = function(type) {
            return $http({
                method: 'DELETE',
                url: baseUrl,
                data: {type: type}
            });
        };

        return resource;
    }]);

    var ntfMgrInst;

    module.service('ntfBubbleManager', function() {
        return new diy.editor.notifications.BubbleManager(toolbar, layerManager);
    });

    module.factory('ntfNotificationFactory', function() {
        return diy.editor.notifications.NotificationFactory;
    });

    module.factory('ntfQueue', function() {
        return diy.editor.notifications.queue;
    });

    diy.angular.loadFactories(module, ['diyglobalevents']);

    module.service('ntfApi',
        ['$rootScope', 'diyglobalevents', 'ntfRest', 'ntfBubbleManager', 'ntfNotificationFactory', 'ntfQueue',
        function($rootScope, diyglobalevents, ntfRest, ntfBubbleManager, ntfNotificationFactory, ntfQueue) {
        var NotificationMgr = Klazz.extend({
            notifications: null,
            flashNotifications: null,
            bubbleManager: null,
            pauseMode: false,
            existingBubblesOnPause: null,
            /**
             * Flag which tells if the list of notifications is fully initialized
             * e.g. notification list was loaded from the server and it was updated
             * by ntfQueue.ready hooks
             */
            notificationsInitialized: null,

            initialize: function() {
                this.notifications = [];
                this.flashNotifications = [];
                this.notificationsInitialized = false;
                this.initBubbleManager();
            },

            initBubbleManager: function() {
                this.bubbleManager = ntfBubbleManager;
            },

            loadNotifications: function(success) {
                ntfRest.query(function(resources) {
                    this.notifications = [];

                    $.each(resources, function(i, resource) {
                        this.notifications.push(
                            ntfNotificationFactory.create(resource)
                        );
                    }.bind(this));

                    if(!this.isPaused()) {
                        this._emitBubbles();
                    }
                    this.notificationsInitialized = true;

                    ntfQueue.process();

                    if (typeof success == 'function') {
                        success(this.notifications);
                    }

                }.bind(this));
            },

            isPaused: function() {
                return this.pauseMode;
            },

            pause: function() {
                if (this.pauseMode) {
                    return;
                }
                this.pauseMode = true;
                this.existingBubblesOnPause = this.bubbleManager.getNotificationIds();
                this.markAllAsDismissed();
            },

            resume: function() {
                if (!this.pauseMode) {
                    return;
                }
                this.pauseMode = false;
                if (this.existingBubblesOnPause != null) {
                    this.existingBubblesOnPause.forEach(function(i) {
                        try {
                            this.updateNotification(i, {dismissed: false});
                        } catch (e) {
                            // the error is most probably triggered by attempt to update
                            // a non existing notification or id=null
                            // instead to raise the error we prefer to silent fail because
                            // the cause of this was allready treated at the cause
                        }
                        this.existingBubblesOnPause.delete(i);
                    }.bind(this));
                }
                this._emitBubbles();
            },

            getNotificationById: function(id) {
                var ret = false;
                this.notifications.some(function(notification) {
                    if (notification.getId() == id) {
                        ret = notification;
                        return true;
                    }
                    return false;
                });

                if (!ret) {
                    throw new Error("No notification found with id " + id);
                }

                return ret;
            },

            createNotification: function(options, success) {
                if (typeof options !== 'object') {
                    throw new Error("Options is not an object");
                }

                if (!options.type) {
                    throw new Error("Must specify the notification type");
                }

                var n = ntfNotificationFactory.create(options.type);

                //TODO: filter and validate options
                var notifItem = new ntfRest({
                    type: options.type,
                    category: options.category ? options.category : n.getCategory(),
                    severity: options.severity ? options.severity : n.getSeverity(),
                    sticky: options.sticky ? (options.sticky ? 1 : 0) : n.getSticky(),
                    payload: options.payload ? options.payload : n.getPayload(),
                    read: options.read ? (options.read ? 1 : 0) : n.getRead(),
                    dismissed: options.dismissed ? (options.dismissed ? 1 : 0) : n.getDismissed(),
                    deleted: options.deleted ? (options.deleted ? 1 : 0) : n.getDeleted()
                });

                n.setResource(notifItem);

                if (!n.flashNotification) {
                    this.notifications.push(n);

                    notifItem.$save(function() {
                        if (this.notificationsInitialized && !this.isPaused()) {
                            this._emitBubble(n);
                        }
                        //$scope.unreadDirty = true;
                        if (typeof success == 'function') {
                            success(notifItem.id);
                        }
                    }.bind(this));
                } else {
                    if (this.notificationsInitialized && !this.isPaused()) {
                        this._emitBubble(n);
                    }
                }
                return n;
            },

            updateNotification: function(id, data, success) {
                var notification = this.getNotificationById(id),
                    wasDismissed = notification.getDismissed();

                if (typeof data.severity !== 'undefined') {
                    notification.setSeverity(data.severity);
                }

                if (typeof data.dismissed !== 'undefined') {
                    notification.setDismissed(data.dismissed ? 1 : 0);
                }

                if (typeof data.sticky !== 'undefined') {
                    notification.setSticky(data.sticky ? 1 : 0);
                }

                if (typeof data.read !== 'undefined') {
                    notification.setRead(data.read ? 1 : 0);
                }

                if (typeof data.payload !== 'undefined') {
                    notification.setPayload(data.payload);
                }

                var ntfInitialized = this.notificationsInitialized;
                notification._resource.$update(function() {
                    if (!notification.getDismissed() && wasDismissed && ntfInitialized && !this.isPaused()) {
                        this._emitBubble(notification);
                    }

                    $rootScope.$broadcast('notifications-changed');
                    if (typeof success == 'function') {
                        success(notification);
                    }
                }.bind(this));
            },

            deleteNotification: function(id, success) {
                var notification = this.getNotificationById(id),
                // Leave this here, we don't want a reference to notification in the closure
                    elementIndex = this.notifications.indexOf(notification);

                if (notification.softDeletion) {
                    notification.setDeleted(1);
                    notification._resource.$update(function() {
                        $rootScope.$broadcast('notifications-changed');
                        if (typeof success == 'function') {
                            success(notification);
                        }
                    });
                } else {
                    notification._resource.$delete(function() {
                        this.notifications.splice(elementIndex , 1);
                        if (typeof success == 'function') {
                            success(notification);
                        }
                    }.bind(this));
                }
            },

            deleteNotificationByType: function(type) {
                var softDeletion = false;
                var ids = [];
                this.notifications = this.notifications.filter(function(notification) {
                    if (notification._resource.type == type) {
                        softDeletion = notification.softDeletion;
                        notification.setDeleted(1);
                        ids.push(notification.getId());
                        return softDeletion;
                    } else {
                        return true;
                    }
                });

                if (softDeletion) {
                    ntfRest.batchSoftDelete({ids: ids});
                    $rootScope.$broadcast('notifications-changed');
                } else {
                    ntfRest.deleteByType(type);
                }
            },

            deleteNotificationByCategory: function(category) {
                var deleteIds = [],
                    softDeleteIds = [];
                this.notifications = this.notifications.filter(function(notification) {
                    if (notification.getSticky()) {
                        return true;
                    }
                    if (notification.getCategory() == category) {
                        notification.setDeleted(1);
                        if (notification.softDeletion) {
                            softDeleteIds.push(notification.getId());
                        } else {
                            deleteIds.push(notification.getId());
                        }
                        return notification.softDeletion;
                    } else {
                        return true;
                    }
                });
                if (softDeleteIds.length > 0) {
                    ntfRest.batchSoftDelete({ids: softDeleteIds});
                    $rootScope.$broadcast('notifications-changed');
                }
                if (deleteIds.length > 0) {
                    ntfRest.batchDelete(deleteIds);
                }
            },

            getNotificationsByType: function(type) {
                var ret = [];
                this.notifications.some(function(notification) {
                    if (notification._resource.type == type) {
                        ret.push(notification);
                    }
                });
                return ret;
            },

            getUnreadNotifications: function() {
                return this.notifications.filter(function(notification) {
                    return notification.getRead() === 0;
                });
            },

            getUnreadCount: function() {
                return this.getUnreadNotifications().length;
            },

            markAllAsRead: function() {
                var currentCount = this.getUnreadCount();

                if (currentCount == 0) {
                    // prevent an unnecessary request to the server
                    return;
                }

                var unreadNotifications = this.getUnreadNotifications();
                var ids = [];
                unreadNotifications.forEach(function(notification) {
                    ids.push(notification.getId());
                });

                ntfRest.markread({
                    ids: ids
                }, function() {
                    unreadNotifications.forEach(function(notification) {
                        notification.setRead(1);
                    });
                });
            },

            markAllAsDismissed: function() {
                var nonDismissedIds = [];
                this.notifications.forEach(function(notification) {
                    if (!notification.getDismissed()) {
                        nonDismissedIds.push(notification.getId());
                        notification.setDismissed(1);
                    }
                });

                if (nonDismissedIds.length === 0) {
                    return;
                }

                this.bubbleManager.destroyAllBubbles();

                ntfRest.markdismissed({
                   ids: nonDismissedIds
                });
            },

            _emitBubbles: function() {
                $.each(this.notifications, function(i, notification) {
                    this._emitBubble(notification);
                }.bind(this));
            },

            _emitBubble: function(notification) {
                if (notification.getDeleted() || notification.getDismissed()) {
                    return false;
                }

                if (diy.editor.notifications.notificationCenter.isLayerOpened()) {
                    if (notification.getId()) {
                        this.updateNotification(notification.getId(), { dismissed: 1 });
                    }
                    return false;
                }

                if (this.bubbleManager.bubbleExists(notification.getId())) {
                    return false;
                }

                var clickCallback = notification.bubbleOptions.clickCallback;
                if (typeof clickCallback === "undefined") {
                    clickCallback = function() {
                        if ($.isFunction(notification.globalAction)) {
                            $(document).trigger('diy-editor-generic-sectionAccessed', {
                                sectionCodeName: 'notificationClicked',
                                propName: notification.getName()
                            });

                            notification.globalAction();
                        }

                        if (notification.getId()) {
                            this.updateNotification(notification.getId(), {
                                dismissed: 1,
                                read: 1
                            });
                        }
                    }.bind(this);
                }

                var content = notification.getContent();
                var isContentEl = content instanceof $;

                this.bubbleManager.pushBubble({
                    notificationId: notification.getId(),
                    severity: notification.getSeverityClass(),
                    icon: (notification.iconCls ? notification.iconCls : null),
                    autoHide: notification.bubbleOptions.autoHide,
                    hideDelay: notification.bubbleOptions.hideDelay,
                    dismissCallback: notification.bubbleOptions.dismissCallback,
                    content: isContentEl ? undefined : content,
                    contentEl: isContentEl ? content.clone(true) : null,
                    clickCallback: clickCallback,
                    clsSuffix: notification.getCssClassSuffix(),
                    closable: notification.bubbleOptions.closable
                });
                return true;
            }
        });

        //Make sure the service always returns the same instance. Otherwise,
        //it will make new instances for each angular module instance
        if (!ntfMgrInst) {
            ntfMgrInst = new NotificationMgr();
        }

        //return new NotificationMgr();
        return ntfMgrInst;

    }]);

    exports.setToolbar = function(_toolbar) {
        toolbar = _toolbar;
    };

    exports.setLayerManager = function(_lm) {
        layerManager = _lm;
    };

}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/notification-module.js
 ** module id = 675
 ** module chunks = 0
 **/